import React from 'react';
import routes from "../../../assets/apiRoutes.json";
import { connect } from "react-redux";
import FileUploader from 'devextreme-react/file-uploader';
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import notify from 'devextreme/ui/notify';
import { LoadPanel } from 'devextreme-react/load-panel';
import DataGrid, {
    Column,
    Editing,
    Paging,
    RequiredRule,
    StringLengthRule,
    Toolbar,
    Item,
    FilterRow,
    Selection,
    FilterPanel,
    FilterBuilderPopup,
    ColumnChooser,
    ColumnChooserSearch,
    ColumnFixing,
    Sorting,
    Export,
    Pager,
    HeaderFilter,
    Lookup,
    StateStoring
} from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import axios from "axios";
import {
    OrchardTypeArr,
    ElevationArr,
    SpeciesArr,
    BlockCycleArr,
    StimCycleArr,
    StimStatusArr,
    BreedingAreaArr,
    PositionArr
  } from '../const/StaticData';

const dataGrid = React.createRef();
let accessToken = '';
const gridKey = "f7b24d11-7a90-455f-98a6-8f432b00835f";
const loadState = () => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null, "Default"); }
const saveState = (state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, "Default"); }

class UploadRametCodes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            isVisileRametCodesGrid: false,
            loadIndicatorVisible: false,
            selectedItemKeys: []
        }
        accessToken = props.oidc.user.access_token;
        this.onUpload = this.onUpload.bind(this);
        this.onUploadError = this.onUploadError.bind(this);
        this.onUploadStarted = this.onUploadStarted.bind(this);
        this.headers = { access_token: accessToken, 'Authorization': `Bearer ${accessToken}` };
        this.onContentReady = this.onContentReady.bind(this);
        this.BlockDataSource = this.BlockDataSource.bind(this);
        this.LocationDataSource = this.LocationDataSource.bind(this);
        this.AddToDBClick = this.AddToDBClick.bind(this);
        this.CancelImport = this.CancelImport.bind(this);
        this.selectionChanged = this.selectionChanged.bind(this);

        this.dataSource = createStore({
            key: 'rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetImportedRametCodes}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.UpdateRametCode}`,
            deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.DeleteRametCode}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            },
            onLoaded: function (e) {
                this.setState({ loadIndicatorVisible: false });
            }.bind(this)
        });

        this.PositionEditorOptions = {
            format: {
                type: "#",
                min: 0,
                max: 3099
            },
        };
        this.allowedPageSizes = [5, 10, 20, 50, 100, 500, 1000, "all"];
        this.filterBuilderPopupPosition = {
            of: window,
            at: 'top',
            my: 'top',
            offset: { y: 10 },
        };
        this.OrderEditorOptions = {
            format: {
                type: "#",
                min: 0
            },
        };
        this.OrchardDataSource = createStore({
            key: "id",
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Orchard.GetAllOrchardCodes}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        });
        this.userStatusDataSource = createStore({
            key: "code",
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetUserStatusCodes}`,
            onBeforeSend: function(method, ajaxOptions) {
              ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
              };
            }
          });
    }
    BlockDataSource(options) {
        return {
            store: createStore({
                key: "id",
                loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Blocks.GetAllBlockCodes}`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            filter: options.data ? ['R_WareHouse', '=', options.data.orchard] : null
        };
    }
    LocationDataSource(options) {
        return {
            store: createStore({
                key: "id",
                loadUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetAllLocationCodes}`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                },
            }),
            filter: options.data ?
                [['R_WareHouse', '=', options.data.orchard], "AND",
                ['R_Location', '=', options.data.block]]
                : null
        };
    }
    onContentReady(e) {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", this.dataSource);
        }
    }
    onUpload(e) {
        console.log("SUCESS!!");
        console.log(e);
        if (e.request.status === 200) {
            this.setState({
                isVisileRametCodesGrid: true,
                //loadIndicatorVisible: false
            });
        }
        console.log(e.request.status);

    }
    onUploadStarted() {
        this.setState({
            isVisileRametCodesGrid: false,
            loadIndicatorVisible: true
        });
    }
    onUploadError(e) {
        console.log(e);
        console.log("ERROR!!");
        this.setState({
            isVisileRametCodesGrid: false,
            loadIndicatorVisible: false
        });
        notify({
            message: e.request.responseText,
            width: 450,
        }, 'error', 2000);
    }
    setOrchardStateValue(rowData, value) {
        rowData.block = null;
        rowData.location = null;
        this.defaultSetCellValue(rowData, value);
    }
    setBlockStateValue(rowData, value) {
        rowData.location = null;
        this.defaultSetCellValue(rowData, value);
    }
    selectionChanged(data) {
        this.setState({
          selectedItemKeys: data.selectedRowKeys,
        });
      }
    AddToDBClick() {
        this.setState({
            loadIndicatorVisible: true
        });
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.RametCodes.UpdateRametCodesRecordTypeForImport}`, this.state.selectedItemKeys,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                if (response.status == 200)
                    this.props.parentCallback();
                else {
                    this.setState({
                        loadIndicatorVisible: false
                    });
                    notify({
                        message: "Some Error Occurred.",
                        width: 450,
                    }, 'error', 2000);
                }
            })
            .catch((err) => {
                notify({
                    message: "Some Error Occurred.",
                    width: 450,
                }, 'error', 2000);
                this.setState({
                    loadIndicatorVisible: false
                });
            });

    }
    CancelImport() {
        this.setState({
            loadIndicatorVisible: true
        });
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.RametCodes.DeleteRametCodesForImport}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                if (response.status == 200)
                    this.props.parentCallback();
                else {
                    this.setState({
                        loadIndicatorVisible: false
                    });
                    notify({
                        message: "Some Error Occurred.",
                        width: 450,
                    }, 'error', 2000);
                }
            })
            .catch((err) => {
                notify({
                    message: "Some Error Occurred.",
                    width: 450,
                }, 'error', 2000);
                this.setState({
                    loadIndicatorVisible: false
                });
            });
    }

    render() {
        return (
            <div>
                <div className='row'>
                    <LoadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        visible={this.state.loadIndicatorVisible}
                        showIndicator={true}
                        shading={true}
                        showPane={true}
                        hideOnOutsideClick={false}
                    />
                    <form>
                        <div className='col-md-12'>
                            <FileUploader selectButtonText="Select a file"
                                labelText="Choose a CSV file"
                                invalidFileExtensionMessage="File Extension not allowed."
                                allowedFileExtensions={['.csv']}
                                accept=".csv" uploadMode="useButtons"
                                uploadUrl={`${window._env_.REACT_APP_APIS}/${routes.RametCodes.UploadCSVFile}`}
                                uploadHeaders={this.headers}
                                onUploadStarted={this.onUploadStarted}
                                onUploaded={this.onUpload}
                                onUploadError={this.onUploadError}
                            />
                        </div>
                    </form>
                </div>
                {this.state.isVisileRametCodesGrid &&
                    <div>
                        <div className='row'>
                            <h5 className='ml-4 mt-4 text-primary font-weight-bold'>Preview Imported Ramets</h5>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
                                    onContentReady={this.onContentReady}
                                    ref={dataGrid}
                                    visible={this.state.isVisileRametCodesGrid}
                                    showBorders={true}
                                    className="customDataTableDesign"
                                    onSelectionChanged={this.selectionChanged}
                                    rowAlternationEnabled={true}
                                    allowColumnReordering={true}
                                    columnAutoWidth={true}>
                                    <Paging enabled={true} />
                                    <Pager
                                        visible={true}
                                        showPageSizeSelector={true}
                                        allowedPageSizes={this.allowedPageSizes}
                                        showNavigationButtons={true}
                                        showInfo={true} />
                                    <FilterRow visible={true} />
                                    <FilterPanel visible={true} />
                                    <FilterBuilderPopup position={this.filterBuilderPopupPosition} />
                                    <ColumnChooser
                                        enabled={true}
                                        title="Choose Column"
                                        width={290}
                                        height={290}
                                        sortOrder="asc">
                                        <ColumnChooserSearch
                                            enabled={true}
                                            editorOptions={{ placeholder: 'Search column' }} />
                                    </ColumnChooser>
                                    <Selection mode="multiple" />
                                    <HeaderFilter visible={true} />
                                    <ColumnFixing enabled={true} />,
                                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                                    <Sorting mode="multiple" />
                                    <LoadPanel enabled={true} />
                                    <Editing
                                        mode="cell"
                                        newRowPosition="first"
                                        refreshMode="repaint"
                                        allowUpdating={true}
                                        allowAdding={false}
                                        allowDeleting={true} />
                                    <StateStoring
                                        enabled={true}
                                        type="custom"
                                        customLoad={loadState}
                                        storageKey={gridKey}
                                        customSave={saveState}
                                    />
                                    <Column
                                        dataField="orchard"
                                        caption="Orchard"
                                        allowEditing={false}
                                        cssClass="column-readonly"
                                        setCellValue={this.setOrchardStateValue}>
                                        <Lookup
                                            displayExpr="name"
                                            valueExpr="id"
                                            dataSource={this.OrchardDataSource} />
                                    </Column>
                                    <Column
                                        dataField="block"
                                        caption="Block"
                                        allowEditing={false}
                                        cssClass="column-readonly"
                                        setCellValue={this.setBlockStateValue}>
                                        <Lookup
                                            dataSource={this.BlockDataSource}
                                            displayExpr="name"
                                            valueExpr="id" />
                                    </Column>
                                    <Column dataField="location" caption="Location">
                                        <Lookup
                                            dataSource={this.LocationDataSource}
                                            displayExpr="name"
                                            valueExpr="id" />
                                    </Column>
                                    <Column dataField="code" caption="Code">
                                        <RequiredRule message="Code(Ramet) is required." />
                                        <StringLengthRule message="Code must have at least 3 chracters and maximum 20." min={3} max={20} />
                                    </Column>
                                    <Column dataField="description" caption="Description" visible={false}>
                                        <StringLengthRule message="Description can have maximum 100 characters." max={100} />
                                    </Column>
                                    <Column dataField="orchardtype" caption="Orchard Type" visible={false}>
                                        <Lookup
                                            dataSource={OrchardTypeArr}
                                            displayExpr="name"
                                            valueExpr="value" />
                                    </Column>
                                    <Column dataField="elevation" caption="Elevation" visible={false}>
                                        <Lookup
                                            dataSource={ElevationArr}
                                            displayExpr="name"
                                            valueExpr="value" />
                                    </Column>
                                    <Column dataField="species" caption="Species" visible={false}>
                                        <Lookup
                                            dataSource={SpeciesArr}
                                            displayExpr="name"
                                            valueExpr="value" />
                                    </Column>
                                    <Column dataField="blockcycle" caption="Block Cycle" visible={false}>
                                        <Lookup
                                            dataSource={BlockCycleArr}
                                            displayExpr="name"
                                            valueExpr="value" />
                                    </Column>
                                    <Column dataField="stimcycle" caption="Stim Cycle" visible={false}>
                                        <Lookup
                                            dataSource={StimCycleArr}
                                            displayExpr="name"
                                            valueExpr="value" />
                                    </Column>
                                    <Column dataField="stimstatus" caption="Stim Status" visible={false}>
                                        <Lookup
                                            dataSource={StimStatusArr}
                                            displayExpr="name"
                                            valueExpr="value" />
                                    </Column>
                                    <Column dataField="breedingarea" caption="Breeding Area" visible={false}>
                                        <Lookup
                                            dataSource={BreedingAreaArr}
                                            displayExpr="name"
                                            valueExpr="value" />
                                    </Column>
                                    <Column dataField="rootstock" caption="Root Stock" visible={false}>
                                        <StringLengthRule message="Root Stock can have maximum 20 characters." max={20} />
                                    </Column>
                                    <Column dataField="parent" caption="Parent" visible={false}>
                                        <StringLengthRule message="Parent can have maximum 50 characters." max={50} />
                                    </Column>
                                    <Column dataField="graftdate" dataType="date" caption="Graft Date"></Column>
                                    <Column dataField="plantdate" dataType="date" caption="Plant Date"></Column>
                                    <Column dataField="userstatus" caption="User Status" visible={false}>
                                        <Lookup
                                            dataSource={this.userStatusDataSource}
                                            displayExpr="description1"
                                            valueExpr="code" />
                                    </Column>
                                    <Column dataField="posy" caption="Row" dataType="number" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                                    <Column dataField="posx" caption="Col" dataType="number" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                                    <Toolbar>
                                        <Item location="before">
                                            <Button onClick={this.AddToDBClick}
                                                text="Add To Database"
                                                type="default"
                                                stylingMode="contained"
                                                className="margin-right" />
                                        </Item>
                                        <Item location="before">
                                            <Button onClick={this.CancelImport}
                                                text="Cancel Import"
                                                type="default"
                                                stylingMode="contained"
                                                className="margin-right" />
                                        </Item>
                                        <Item name="exportButton" />
                                        <Item name="columnChooserButton" />
                                    </Toolbar>
                                </DataGrid>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UploadRametCodes);